module.exports = __webpack_public_path__ + "media/src/images/balloons/womans_day_headline_de-e6ae6fc67d73892f6139529dd7889920.png";